import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { setAreasSearch } from "../../store/reducers/fortalezas/fortalezas.reducer";
import SearchInput from "../UI/SearchInput";

const AreasHeader = () => {
  const dispatch = useDispatch();
  const { areasSearch } = useSelector((state) => state.fortalezas);

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold d-flex align-items-center gap-2">
            <Icon icon="mdi:shape-outline" width="22" />
            Áreas de Desarrollo
          </h5>
        </div>
        <div className="col-12 col-md">
          <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end">
            <SearchInput
              value={areasSearch}
              onChange={(value) => dispatch(setAreasSearch(value))}
              placeholder="Buscar áreas..."
              minChars={3}
              className="flex-grow-1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreasHeader;
